import { FilterOption } from "./FilterPopover.types.ts";
import { mapInputFieldTypeToFilterOptionType } from "./inputFieldFilterTypeMapping.ts";
import { SelectableInputField } from "../../../entityTemplates/EntityTemplate.types.ts";
import { InputFieldTypeEnum } from "../../../entityTemplates/inputFields/InputFields.types.ts";
import { EntityType } from "@common/Common.types.ts";
import { getResponsibleQueryUrl } from "../../../user/hooks/useResponsibleQuery.ts";
import { CustomFieldFilter } from "@common/api/filterTypes.ts";
import { IdNamePair } from "../../../customLists/customListView/CustomListView.types.ts";

// The prefix that marks a filter bar entry as one of a template's custom fields rather than a built-in column.
// FilterBar strips it again before asking /filter-data for chip labels.
export const customFieldFilterIdPrefix = "custom-field-";

// Each option carries the field's input type so the submenu and the chip know which editor to draw.
export function buildCustomFieldFilterOption(
    customField: SelectableInputField,
    customFieldFilters: Array<CustomFieldFilter> | undefined,
    selectableCountries: Array<IdNamePair>
): FilterOption {
    const option: FilterOption = {
        id: `${customFieldFilterIdPrefix}${customField.id}`,
        label: customField.name,
        type: mapInputFieldTypeToFilterOptionType(customField.type),
        value: customFieldFilters?.find((filter) => filter.inputFieldId === customField.id)?.value ?? "",
        customInputType: customField.type,
    };

    switch (customField.type) {
        case InputFieldTypeEnum.UserField:
            option.dataUrl = getResponsibleQueryUrl();
            break;
        case InputFieldTypeEnum.LegalEntityField:
            option.entityType = EntityType.LegalEntity;
            break;
        case InputFieldTypeEnum.CountryField:
            option.fixedData = selectableCountries;
            break;
        case InputFieldTypeEnum.SingleDropDown:
        case InputFieldTypeEnum.MultiDropDown:
            option.dataUrl = `/settings/input-fields/${customField.id}/select-options`;
            break;
    }

    return option;
}
